import type { ReactNode } from "react";
import { Link } from "react-router";

type ButtonProps = {
  children: ReactNode;
  variant?: "primary" | "outline" | "dark" | "light";
  size?: "sm" | "md" | "lg";
  fullWidth?: boolean;
  to?: string;
  onClick?: () => void;
  className?: string;
};

export const ActionButton = ({
  children,
  variant = "primary",
  size = "md",
  fullWidth = false,
  to,
  onClick,
  className,
}: ButtonProps) => {
  const classes = [
    "sg-button",
    `sg-button--${variant}`,
    `sg-button--${size}`,
    fullWidth ? "is-full" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (to) {
    return (
      <Link to={to} className={classes}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" className={classes} onClick={onClick}>
      {children}
    </button>
  );
};
